import React from 'react';
import { Typography, IconButton, Grid, Chip } from '@mui/material';
import { CancelOutlined } from "@mui/icons-material";
import { FileItemProps, UploadedFile } from '@/Contexts/Funnel/types';
import { CheckCircle, Error, CloudUpload } from "@mui/icons-material";
import { blue, green, grey, red } from '@mui/material/colors';
import { formatFileSize } from '@/utils/helperFunctions';

const getStatusIcon = (file: UploadedFile) => {
  switch (file.uploadStatus) {
    case 'completed':
      return <CheckCircle sx={{ color: green[500], fontSize: 20 }} />;
    case 'error':
      return <Error sx={{ color: red[500], fontSize: 20 }} />;
    case 'uploading':
      return <CloudUpload sx={{ color: blue[500], fontSize: 20 }} />;
    default:
      return null;
  }
};

const getStatusColor = (file: UploadedFile) => {
  switch (file.uploadStatus) {
    case 'completed':
      return green[500];
    case 'error':
      return red[500];
    case 'uploading':
      return blue[500];
    default:
      return grey[500];
  }
};

const getStatusText = (file: UploadedFile) => {
  switch (file.uploadStatus) {
    case 'completed':
      return 'Uploaded';
    case 'error':
      return 'Failed';
    case 'uploading':
      return 'Uploading...';
    case 'pending':
      return 'Pending';
    default:
      return '';
  }
};

const FileItem: React.FC<FileItemProps> = ({ file, onRemove }) => {

  return (
    <Grid
      container
      direction="column"
      spacing={1}
      sx={{
        p: 2,
        mb: 1,
        border: "1px solid",
        borderColor: file.uploadStatus === 'error' ? red[300] : grey["300"],
        borderRadius: 1,
      }}
    >
      <Grid container alignItems="center" justifyContent="space-between" wrap="nowrap">
        <Grid container alignItems="center" spacing={1}>
          <Grid>
            {getStatusIcon(file)}
          </Grid>
          <Grid>
            <Typography variant="body1" sx={{ fontWeight: "medium", lineHeight: 1.2 }}>
              {file.name}
            </Typography>
            <Typography variant="body2" sx={{ color: grey["500"] }}>
              {formatFileSize(file.size)}
            </Typography>
          </Grid>
        </Grid>

        <Grid container alignItems="center" spacing={1}>
          {file.uploadStatus && (
            <Grid>
              <Chip
                label={getStatusText(file)}
                size="small"
                sx={{
                  backgroundColor: getStatusColor(file),
                  color: 'white',
                  fontSize: '0.75rem',
                }}
              />
            </Grid>
          )}
          <Grid>
            <IconButton
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onRemove(file.id);
              }}
            >
              <CancelOutlined />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>

      {file.uploadStatus === 'error' && file.error && (
        <Grid>
          <Typography variant="body2" sx={{ color: red[500], fontSize: '0.75rem' }}>
            {file.error}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default FileItem;
